<template>
  <div class="container-item bg-black mb-3 mt-3">  
    <div class="container">
    <div class="row justify-content-center">
     <div class="col-12 col-md-10">
      <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 755.24 597.73">
        <defs>
          
          <clipPath id="clippath">
            <circle class="cls-1" cx="677.65" cy="220.29" r="30.97"/>
          </clipPath>
          <clipPath id="clippath-1">
            <circle class="cls-1" cx="661.86" cy="291.55" r="31.02"/>
          </clipPath>
          <clipPath id="clippath-2">
            <circle class="cls-1" cx="643.03" cy="371.14" r="31.22"/>
          </clipPath>
          <clipPath id="clippath-3">
            <circle class="cls-1" cx="581.54" cy="419.84" r="31.56"/>
          </clipPath>
          <clipPath id="clippath-4">
            <circle class="cls-1" cx="363.61" cy="527.91" r="35.13"/>
          </clipPath>
          <clipPath id="clippath-5">
            <circle class="cls-1" cx="427.65" cy="454.21" r="35.13"/>
          </clipPath>
          <clipPath id="clippath-6">
            <circle class="cls-1" cx="107.2" cy="418.51" r="35.55"/>
          </clipPath>
          <clipPath id="clippath-7">
            <circle class="cls-1" cx="108.61" cy="325.22" r="36.11"/>
          </clipPath>
          <clipPath id="clippath-8">
            <circle class="cls-1" cx="144.34" cy="502.56" r="35.8"/>
          </clipPath>
          <clipPath id="clippath-9">
            <circle class="cls-1" cx="232.32" cy="559.09" r="36.35"/>
          </clipPath>
          <clipPath id="clippath-10">
            <circle class="cls-1" cx="247.08" cy="83.18" r="33.18"/>
          </clipPath>
          <clipPath id="clippath-11">
            <circle class="cls-1" cx="383.44" cy="72" r="32.61"/>
          </clipPath>
          <clipPath id="clippath-12">
            <circle class="cls-1" cx="102.2" cy="229.09" r="33.31"/>
          </clipPath>
          <clipPath id="clippath-13">
            <circle class="cls-1" cx="135.02" cy="149.03" r="33.42"/>
          </clipPath>
          <clipPath id="clippath-14">
            <circle class="cls-1" cx="630.05" cy="161.18" r="33.12"/>
          </clipPath>
          <clipPath id="clippath-15">
            <circle class="cls-1" cx="563.61" cy="113.85" r="32.22"/>
          </clipPath>
          <clipPath id="clippath-16">
            <circle class="cls-1" cx="498.53" cy="65.59" r="32.65"/>
          </clipPath>
          <image id="image" width="850" height="850" xlink:href="/wp-content/interactivos/factchecking-loreto/fotos_involucrados/jhuliana_rivas.jpg"/>
        </defs>
        <g id="Layer_15" data-name="Layer 15">
          <g>
            <path class="cls-10" d="M461.11,268.31c-.02-.25-.05-.51-.07-.77"/>
            <path class="cls-11" d="M460.96,265.96c-.12-3.63.24-7.59.97-11.83"/>
            <path class="cls-11" d="M462.06,253.34c7.38-40.64,47.93-106.33,32.95-151.86"/>
            <path class="cls-10" d="M494.76,100.73c-.08-.24-.17-.49-.26-.73"/>
          </g>
          <g>
            <path class="cls-10" d="M461.11,268.31c.04-.25.08-.51.13-.76"/>
            <path class="cls-8" d="M461.58,266.05c.89-3.27,2.64-6.71,5.07-10.29"/>
            <path class="cls-8" d="M467.09,255.12c19.29-27.75,77.65-64.52,84.25-106.26"/>
            <path class="cls-10" d="M551.46,148.1c.04-.26.07-.51.1-.77"/>
          </g>
          <g>
            <path class="cls-10" d="M461.11,268.31c.2-.16.4-.32.6-.49"/>
            <path class="cls-2" d="M462.91,266.87c2.54-1.97,5.68-4.23,9.36-6.73"/>
            <path class="cls-2" d="M472.91,259.71c27.25-18.41,82.39-49.28,134.45-72.53"/>
            <path class="cls-10" d="M608.06,186.87c.24-.11.47-.21.71-.32"/>
          </g>
          <g>
            <path class="cls-10" d="M461.11,268.31c.22-.13.44-.26.67-.39"/>
            <path class="cls-4" d="M463.16,267.14c3.22-1.76,6.85-3.43,10.82-5.02"/>
            <path class="cls-4" d="M474.72,261.83c45.35-17.87,133.92-25.36,171.52-27.33"/>
            <path class="cls-10" d="M647.03,234.45c.26-.01.52-.03.77-.04"/>
          </g>
          <g>
            <path class="cls-10" d="M461.11,268.31c.25.05.51.11.76.16"/>
            <path class="cls-18" d="M463.39,268.79c3.9.8,7.72,1.48,11.46,2.07"/>
            <path class="cls-18" d="M475.62,270.97c57.6,8.79,98.13-5.78,152.43,17.82"/>
            <path class="cls-10" d="M628.76,289.1c.24.1.47.21.71.31"/>
          </g>
          <g>
            <path class="cls-10" d="M461.11,268.31c.23.11.47.22.7.33"/>
            <path class="cls-12" d="M463.24,269.3c3.51,1.64,7.07,3.35,10.68,5.12"/>
            <path class="cls-12" d="M474.63,274.77c50.28,24.79,108.33,61.4,133.95,81.74"/>
            <path class="cls-10" d="M609.2,357c.2.16.4.32.6.48"/>
          </g>
          <g>
            <path class="cls-10" d="M461.11,268.31c.23.12.46.24.69.36"/>
            <path class="cls-9" d="M463.22,269.43c3.75,2.02,7.24,4.03,10.51,6.07"/>
            <path class="cls-9" d="M474.42,275.93c35.17,22.1,45.38,46.82,94.27,108.96"/>
            <path class="cls-10" d="M569.19,385.53c.16.2.32.41.48.61"/>
          </g>
          <g>
            <path class="cls-10" d="M364.77,318.32c-.09.24-.18.49-.26.73"/>
            <path class="cls-7" d="M364.04,320.46c-1.13,3.56-1.88,7.21-2.31,10.91"/>
            <path class="cls-7" d="M361.65,332.11c-4.1,39.67,28.94,85,40.6,91.44"/>
            <path class="cls-10" d="M402.92,423.88c.25.11.49.21.72.28"/>
          </g>
          <g>
            <path class="cls-10" d="M364.77,318.32c-.02.26-.04.52-.06.77"/>
            <path class="cls-3" d="M364.57,320.69c-.34,4.02-.75,8.01-1.2,11.95"/>
            <path class="cls-3" d="M363.29,333.43c-7.48,64.51-27.59,117.63-13.31,157.27"/>
            <path class="cls-10" d="M350.25,491.44c.09.24.18.48.27.72"/>
          </g>
          <g>
            <path class="cls-10" d="M364.77,318.32c-.02.25-.05.51-.08.77"/>
            <path class="cls-5" d="M364.5,320.6c-.52,3.44-1.53,7.14-2.97,11.05"/>
            <path class="cls-5" d="M361.26,332.37c-21.36,56.3-129.69,155.86-128.27,187.18"/>
            <path class="cls-10" d="M233.04,520.31c.03.26.06.51.11.76"/>
          </g>
          <g>
            <path class="cls-10" d="M364.77,318.32c-.09.24-.18.48-.27.72"/>
            <path class="cls-15" d="M363.88,320.48c-1.46,3.18-3.6,6.49-6.34,9.91"/>
            <path class="cls-15" d="M357.05,331c-35.36,43.27-163.56,103.81-187.05,140.62"/>
            <path class="cls-10" d="M169.58,472.29c-.14.22-.27.44-.39.67"/>
          </g>
          <g>
            <path class="cls-10" d="M364.77,318.32c-.09.24-.18.48-.28.72"/>
            <path class="cls-13" d="M363.87,320.42c-1.55,3.15-3.95,6.07-7.06,8.8"/>
            <path class="cls-13" d="M356.24,329.71c-38.62,32.69-180.96,37.37-215.51,63.65"/>
            <path class="cls-10" d="M140.13,393.82c-.2.16-.4.32-.6.49"/>
          </g>
          <g>
            <path class="cls-10" d="M364.77,318.32c-.09.24-.18.48-.28.72"/>
            <path class="cls-14" d="M363.86,320.4c-1.64,3.17-4.24,5.86-7.64,8.14"/>
            <path class="cls-14" d="M355.58,328.95c-40.01,25.41-184.12-3.74-206.69-9.12"/>
            <path class="cls-10" d="M148.16,319.66c-.27-.07-.52-.13-.75-.19"/>
          </g>
          <g>
            <path class="cls-10" d="M284.55,270.78c-.25-.02-.51-.04-.77-.06"/>
            <path class="cls-6" d="M282.24,270.57c-3.37-.38-7.24-1.09-11.52-2.07"/>
            <path class="cls-6" d="M269.96,268.32c-42.81-10.02-124.78-45.81-149.28-39.91"/>
            <path class="cls-10" d="M119.92,228.61c-.25.07-.5.15-.74.24"/>
          </g>
          <g>
            <path class="cls-10" d="M284.55,270.78c-.24-.09-.48-.18-.72-.27"/>
            <path class="cls-19" d="M282.39,269.93c-3.47-1.48-6.83-3.45-10.1-5.82"/>
            <path class="cls-19" d="M271.66,263.65c-35.87-26.67-60.31-101.54-98.8-117.18"/>
            <path class="cls-10" d="M172.13,146.18c-.24-.09-.48-.18-.72-.27"/>
          </g>
          <g>
            <path class="cls-10" d="M284.55,270.78c-.25.08-.49.15-.74.23"/>
            <path class="cls-16" d="M282.39,271.44c-3.45,1.02-7.05,1.97-10.76,2.87"/>
            <path class="cls-16" d="M270.91,274.48c-43.4,10.39-102.01,14.27-122.66,43.74"/>
            <path class="cls-10" d="M147.83,318.83c-.14.21-.29.43-.43.64"/>
          </g>
          <g>
            <path class="cls-10" d="M358.83,225.23c-.04-.25-.1-.5-.16-.76"/>
            <path class="cls-20" d="M358.21,223.01c-1.06-2.85-3.22-6.12-6.21-9.7"/>
            <path class="cls-20" d="M351.5,212.72c-22.25-26.06-87.53-68.28-102.77-91.61"/>
            <path class="cls-10" d="M248.31,120.46c-.14-.22-.27-.44-.4-.66"/>
          </g>
          <g>
            <path class="cls-10" d="M358.83,225.23c-.02-.25-.03-.51-.05-.77"/>
            <path class="cls-17" d="M358.75,222.9c0-3.5.51-7.4,1.41-11.61"/>
            <path class="cls-17" d="M360.32,210.53c6.56-29.5,31.43-73.68,33.1-103.03"/>
            <path class="cls-10" d="M393.46,106.71c.01-.26.02-.52.03-.77"/>
          </g>
          <circle class="cls-32" cx="452.93" cy="269.97" r="9.37"/>
          <circle class="cls-33" cx="364.77" cy="318.32" r="9.81"/>
          <circle class="cls-59" cx="284.55" cy="270.78" r="9.81"/>
          <circle class="cls-21" cx="359.82" cy="228.2" r="9.81"/>
          <g class="cls-25">
            <text class="cls-23" transform="translate(473.86 268.45) rotate(-.31)"><tspan x="0" y="0">GOBIERNO</tspan><tspan class="cls-81" x="0" y="15.83">L</tspan><tspan x="6.21" y="15.83">OCAL</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-24" transform="translate(327.53 344.5) rotate(-.16)"><tspan x="0" y="0">S</tspan><tspan class="cls-72" x="7.54" y="0">E</tspan><tspan class="cls-98" x="14.3" y="0">C</tspan><tspan class="cls-85" x="21.75" y="0">T</tspan><tspan x="28.41" y="0">OR</tspan><tspan x="-3.51" y="15.83">PRI</tspan><tspan class="cls-68" x="16.41" y="15.83">V</tspan><tspan x="23.69" y="15.83">ADO</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-30" transform="translate(218.15 273.4) rotate(-.46)"><tspan x="0" y="0">PREN</tspan><tspan class="cls-89" x="31.74" y="0">S</tspan><tspan class="cls-52" x="39.22" y="0">A</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-31" transform="translate(327.31 275.58) rotate(-.46)"><tspan x="0" y="0">S</tspan><tspan class="cls-74" x="9.17" y="0">E</tspan><tspan class="cls-97" x="17.38" y="0">C</tspan><tspan class="cls-84" x="26.43" y="0">T</tspan><tspan class="cls-57" x="34.53" y="0">OR</tspan><tspan class="cls-97" x="55.5" y="0">E</tspan><tspan x="63.77" y="0">S</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-22" transform="translate(323.7 211.44) rotate(-.48)"><tspan class="cls-67" x="0" y="0">C</tspan><tspan x="7.32" y="0">ONGR</tspan><tspan class="cls-99" x="41.83" y="0">E</tspan><tspan class="cls-56" x="48.64" y="0">SO</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-27" transform="translate(678.42 142.35) rotate(.01)"><tspan x="0" y="0">RENÉ</tspan><tspan x="0" y="11.17">CH</tspan><tspan class="cls-73" x="11.55" y="11.17">Á</tspan><tspan class="cls-54" x="16.75" y="11.17">V</tspan><tspan class="cls-102" x="21.93" y="11.17">E</tspan><tspan x="26.82" y="11.17">Z</tspan><tspan x="0" y="22.35">SI</tspan><tspan class="cls-60" x="7.82" y="22.35">L</tspan><tspan class="cls-71" x="11.73" y="22.35">V</tspan><tspan x="16.78" y="22.35">ANO</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-26" transform="translate(608.93 88.81) rotate(.66)"><tspan x="0" y="0">ERWIN</tspan><tspan x="0" y="11.17">F</tspan><tspan class="cls-77" x="4.57" y="11.17">L</tspan><tspan x="8.79" y="11.17">ORETT</tspan><tspan x="0" y="22.35">DÍAZ</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-28" transform="translate(715.23 210.76) rotate(-.18)"><tspan class="cls-93" x="0" y="0">R</tspan><tspan x="5.55" y="0">ODOL</tspan><tspan class="cls-69" x="29.07" y="0">F</tspan><tspan class="cls-53" x="33.48" y="0">O</tspan><tspan class="cls-78" x="0" y="11.17">L</tspan><tspan class="cls-88" x="4.22" y="11.17">OV</tspan><tspan x="15.75" y="11.17">O</tspan><tspan x="0" y="22.35">TEL</tspan><tspan class="cls-78" x="14.43" y="22.35">L</tspan><tspan x="18.65" y="22.35">O</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-27" transform="translate(701.17 279.36)"><tspan class="cls-95" x="0" y="0">R</tspan><tspan x="5.55" y="0">ODIL</tspan><tspan x="0" y="11.17">TEL</tspan><tspan class="cls-76" x="14.43" y="11.17">L</tspan><tspan x="18.65" y="11.17">O</tspan><tspan class="cls-102" x="0" y="22.35">E</tspan><tspan class="cls-41" x="4.89" y="22.35">SPIN</tspan><tspan class="cls-65" x="24.48" y="22.35">O</tspan><tspan x="30.69" y="22.35">ZA</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-27" transform="translate(680.83 359.02) rotate(.94)"><tspan x="0" y="0">CARMEN</tspan><tspan x="0" y="11.17">C</tspan><tspan class="cls-79" x="5.21" y="11.17">A</tspan><tspan x="10.08" y="11.17">TUN</tspan><tspan class="cls-80" x="27.42" y="11.17">T</tspan><tspan x="31.77" y="11.17">A</tspan><tspan x="0" y="22.35">A</tspan><tspan class="cls-61" x="5.34" y="22.35">L</tspan><tspan class="cls-71" x="9.25" y="22.35">V</tspan><tspan x="14.29" y="22.35">A</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-27" transform="translate(622.1 426.38) rotate(.49)"><tspan x="0" y="0">SOFÍA</tspan><tspan class="cls-86" x="0" y="11.17">S</tspan><tspan x="5.03" y="11.17">ÁNCH</tspan><tspan class="cls-102" x="28.27" y="11.17">E</tspan><tspan x="33.16" y="11.17">Z</tspan><tspan x="0" y="22.35">RE</tspan><tspan class="cls-80" x="10.62" y="22.35">Á</tspan><tspan class="cls-41" x="15.49" y="22.35">T</tspan><tspan class="cls-90" x="20.3" y="22.35">E</tspan><tspan x="25.17" y="22.35">GUI</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-26" transform="translate(407.52 518.42) rotate(-.61)"><tspan x="0" y="0">JHULIANA</tspan><tspan x="0" y="11.17">RI</tspan><tspan class="cls-70" x="8.38" y="11.17">V</tspan><tspan x="13.43" y="11.17">AS</tspan><tspan x="0" y="22.35">PIÑA</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-26" transform="translate(271.96 565.31) rotate(.25)"><tspan x="0" y="0">ENRIQUE</tspan><tspan class="cls-94" x="0" y="11.17">R</tspan><tspan x="5.55" y="11.17">ODRÍGU</tspan><tspan class="cls-92" x="38.41" y="11.17">E</tspan><tspan x="43.3" y="11.17">Z</tspan><tspan class="cls-101" x="0" y="22.35">M</tspan><tspan x="7.15" y="22.35">ORAL</tspan><tspan class="cls-101" x="29.2" y="22.35">E</tspan><tspan x="34.09" y="22.35">S</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-26" transform="translate(80.94 499.01) rotate(1.28)"><tspan x="0" y="0">JOSÉ</tspan><tspan x="-18.84" y="11.17">AN</tspan><tspan class="cls-82" x="-7.14" y="11.17">T</tspan><tspan x="-2.65" y="11.17">ONIO</tspan><tspan x="-11.33" y="22.35">SOPLÍN</tspan><tspan x="-10.3" y="33.52">RÍOS</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-27" transform="translate(20.97 424.49) rotate(-1.31)"><tspan x="0" y="0">WALTER</tspan><tspan x="11.18" y="11.17">BORIA</tspan><tspan x="6.43" y="22.35">J</tspan><tspan class="cls-102" x="9.27" y="22.35">E</tspan><tspan class="cls-91" x="14.16" y="22.35">S</tspan><tspan x="19.13" y="22.35">SON</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-27" transform="translate(15.06 319.8) rotate(-2.02)"><tspan x="0" y="0">CHRI</tspan><tspan class="cls-63" x="19.93" y="0">S</tspan><tspan class="cls-41" x="24.8" y="0">TIAN</tspan><tspan x="7.65" y="11.17">PINAS</tspan><tspan class="cls-66" x="32.58" y="11.17">C</tspan><tspan x="37.61" y="11.17">O</tspan><tspan class="cls-102" x="-14.8" y="22.35">M</tspan><tspan x="-7.64" y="22.35">ONTEN</tspan><tspan class="cls-90" x="21.31" y="22.35">E</tspan><tspan x="26.18" y="22.35">G</tspan><tspan class="cls-95" x="32.06" y="22.35">R</tspan><tspan x="37.61" y="22.35">O</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-27" transform="translate(42.67 219.94)"><tspan class="cls-65" x="0" y="0">L</tspan><tspan x="4.4" y="0">UIS</tspan><tspan x="-11.25" y="11.17">RA</tspan><tspan class="cls-102" x="-.28" y="11.17">M</tspan><tspan x="6.87" y="11.17">OS</tspan><tspan x="-19.42" y="22.35">TENA</tspan><tspan class="cls-64" x="2.08" y="22.35">Z</tspan><tspan class="cls-102" x="6.7" y="22.35">O</tspan><tspan x="13.05" y="22.35">A</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-26" transform="translate(71.69 138.13) rotate(-1.31)"><tspan x="0" y="0">JAIME</tspan><tspan class="cls-70" x="-14.66" y="11.17">V</tspan><tspan x="-9.61" y="11.17">ÁSQU</tspan><tspan class="cls-101" x="13.4" y="11.17">E</tspan><tspan x="18.29" y="11.17">Z</tspan><tspan class="cls-70" x="-22.38" y="22.35">V</tspan><tspan x="-17.34" y="22.35">A</tspan><tspan class="cls-77" x="-12" y="22.35">L</tspan><tspan class="cls-42" x="-7.78" y="22.35">CÁ</tspan><tspan class="cls-94" x="2.77" y="22.35">R</tspan><tspan class="cls-42" x="8.32" y="22.35">CEL</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-27" transform="translate(227.85 18.04) rotate(-1.03)"><tspan class="cls-95" x="0" y="0">R</tspan><tspan x="5.55" y="0">OSÍO</tspan><tspan class="cls-83" x="-2.95" y="11.17">T</tspan><tspan x="1.54" y="11.17">ORR</tspan><tspan class="cls-102" x="19.25" y="11.17">E</tspan><tspan x="24.13" y="11.17">S</tspan><tspan class="cls-86" x="-4.13" y="22.35">S</tspan><tspan x=".9" y="22.35">ALINAS</tspan></text>
          </g>
          <g class="cls-25">
            <text class="cls-27" transform="translate(368.94 8.39) rotate(-.91)"><tspan x="0" y="0">JO</tspan><tspan class="cls-95" x="9.28" y="0">R</tspan><tspan x="14.83" y="0">GE</tspan><tspan class="cls-102" x="-7.51" y="11.17">M</tspan><tspan x="-.36" y="11.17">ORANTE</tspan><tspan x="-.61" y="22.35">FIGARI</tspan></text>
          </g>
          <g class="circle-item" data-name="Rodolfo Lovo" data-role="Alcalde distrital de Contamana. Director de la CDSL hasta 2022." data-category="Gobierno Local">
            <circle class="cls-32" cx="677.89" cy="220.43" r="33.74"/>
            <g class="cls-103">
              <image width="472" height="472" transform="translate(637.12 187.9) scale(.16)" xlink:href="/wp-content/interactivos/factchecking-loreto/fotos_involucrados/rodolfo_lovo.jpg"/>
            </g>
          </g>
          <g class="circle-item" data-name="RODIL TELLO ESPINOZA" data-role="Rector de la Universidad Nacional de la Amazonia Peruana" data-category="Gobierno Local">
            <circle class="cls-32" cx="661.95" cy="291.56" r="33.74"/>
            <g class="cls-43">
              <image width="491" height="491" transform="translate(627.14 259.06) scale(.14)" xlink:href="/wp-content/interactivos/factchecking-loreto/fotos_involucrados/rodil_tello.jpg"/>
            </g>
          </g>
          <g class="circle-item" data-name="CARMEN CATUNTA ALVA" data-role="Gerente de acondicionamiento territorial de la Municipalidad de Maynas. Directora de la CDSL." data-category="Gobierno Local">
            <circle class="cls-32" cx="643.03" cy="371.14" r="33.74"/>
            <g class="cls-46">
              <image width="513" height="513" transform="translate(607.16 339.2) scale(.14)" xlink:href="/wp-content/interactivos/factchecking-loreto/fotos_involucrados/carmen_catunta.jpg"/>
            </g>
          </g>
          <g class="cls-25">
            <text class="cls-27" transform="translate(542.14 40.89) rotate(.96)"><tspan x="0" y="0">VLADIMIR</tspan><tspan x="0" y="11.17">CHONG</tspan><tspan x="0" y="22.35">RÍOS</tspan></text>
          </g>
          <g class="circle-item" data-name="SOFÍA SÁNCHEZ REÁTEGUI" data-role="Gerente regional de desarrollo económico del Gobierno Regional de Loreto" data-category="Gobierno Local">
            <circle class="cls-32" cx="581.66" cy="419.67" r="34.4"/>
            <g class="cls-44">
              <image width="607" height="607" transform="translate(547.34 388.07) scale(.11)" xlink:href="/wp-content/interactivos/factchecking-loreto/fotos_involucrados/sofia_sanchez.jpg"/>
            </g>
          </g>
          <g class="circle-item" data-name="JHULIANA RIVAS PIÑA" data-role="Empresaria del sector inmobiliario. Esposa de Christian Pinasco. Dueña de CPM Satelital." data-category="SECTOR PRIVADO">
            <circle class="cls-58" cx="363.79" cy="528.23" r="38.64"/>
            <g class="cls-45">
              <use transform="translate(325.67 492.42) scale(.09)" xlink:href="#image"/>
            </g>
          </g>
          <g class="circle-item" data-name="SALVITH OJANAMA LÓPEZ" data-role="Militante de Perú Moderno. Directora de la CDSL. Integró el programa de formación ciudadana Parlamento Mujer, organizado por el Congreso. Lideresa de Onajepinc." data-category="SECTOR PRIVADO">
            <circle class="cls-58" cx="427.83" cy="454.54" r="38.64"/>
            <g class="cls-51">
              <image width="527" height="527" transform="translate(387.83 420) scale(.16)" xlink:href="/wp-content/interactivos/factchecking-loreto/fotos_involucrados/salvit_ojanama.jpg"/>
            </g>
          </g>
          <g class="circle-item" data-name="WALTER BORIA JESSON" data-role="Presidente de la Cámara de Comercio de Loreto y director de la CDSL." data-category="SECTOR PRIVADO">
            <circle class="cls-58" cx="107.2" cy="418.51" r="38.64"/>
            <g class="cls-48">
              <image width="527" height="527" transform="translate(70.65 382.03) scale(.14)" xlink:href="/wp-content/interactivos/factchecking-loreto/fotos_involucrados/ricardo_boria.jpg"/>
            </g>
          </g>
          <g class="circle-item" data-name="CHRISTIAN PINASCO MONTENEGRO" data-role="Empresario del sector inmobiliario, dueño de tres medios de comunicación y vinculado a una petrolera. Presidente de la Coordinadora por el Desarrollo Sostenible de Loreto" data-category="SECTOR PRIVADO Y MEDIOS DE COMUNICACIÓN">
            <circle class="cls-58" cx="108.61" cy="325.22" r="38.64"/>
            <g class="cls-47">
              <image width="408" height="408" transform="translate(61.71 284.02) scale(.22)" xlink:href="/wp-content/interactivos/factchecking-loreto/fotos_involucrados/christian_pinasco.jpg"/>
            </g>
          </g>
          <g class="circle-item" data-name="JOSÉ ANTONIO SOPLÍN RÍOS" data-role="Vicedecano del Colegio de Ingenieros de Loreto. Exfuncionario de Perúpetro y empresario del sector hidrocarburos." data-category="SECTOR PRIVADO">
            <circle class="cls-58" cx="144.34" cy="502.56" r="38.64"/>
            <g class="cls-50">
              <image width="1043" height="1043" transform="translate(100.22 466.42) scale(.09)" xlink:href="/wp-content/interactivos/factchecking-loreto/fotos_involucrados/jose_soplin.jpg"/>
            </g>
          </g>
          <g class="circle-item" data-name="ENRIQUE RODRÍGUEZ MORALES " data-role="Director y vocero del Grupo Tecnico de Iquitos. Empresario dueño del hotel 'El Cauchero' " data-category="SECTOR PRIVADO">
            <circle class="cls-58" cx="231.45" cy="559.09" r="38.64"/>
            <g class="cls-49">
              <image width="1650" height="1650" transform="translate(190.86 522.29) scale(.05)" xlink:href="/wp-content/interactivos/factchecking-loreto/fotos_involucrados/enrique_rodriguez.jpg"/>
            </g>
          </g>
          <g class="circle-item" data-name="ROSÍO TORRES SALINAS" data-role="Congresista de Alianza para el Progreso" data-category="CONGRESO">
            <circle class="cls-21" cx="246.91" cy="82.94" r="35.31"/>
            <g class="cls-36">
              <image width="1106" height="1106" transform="translate(208.3 49.38) scale(.07)" xlink:href="/wp-content/interactivos/factchecking-loreto/fotos_involucrados/rosio_torres.jpg"/>
            </g>
          </g>
          <g class="circle-item" data-name="JORGE MORANTE FIGARI" data-role="Congresista de Somos Perú (antes de Fuerza Popular)" data-category="CONGRESO">
            <circle class="cls-21" cx="383.44" cy="72" r="35.31"/>
            <g class="cls-34">
              <image width="471" height="471" transform="translate(348.77 37.76) scale(.15)" xlink:href="/wp-content/interactivos/factchecking-loreto/fotos_involucrados/jorge_morante.jpg"/>
            </g>
          </g>
          <g class="circle-item" data-name="LUIS RAMOS TENAZOA" data-role="Director del medio digital Contraluz" data-category="MEDIOS DE COMUNICACIÓN ">
            <circle class="cls-59" cx="102.84" cy="229.05" r="36.1"/>
            <g class="cls-40">
              <image width="721" height="721" transform="translate(67.01 195.9) scale(.1)" xlink:href="/wp-content/interactivos/factchecking-loreto/fotos_involucrados/luis_ramos_tenazoa.jpg"/>
            </g>
          </g>
          <g class="circle-item" data-name="JAIME VÁSQUEZ VALCÁRCEL" data-role="Director de Pro y Contra" data-category="MEDIOS DE COMUNICACIÓN ">
            <circle class="cls-59" cx="134.7" cy="148.43" r="36.1"/>
            <g class="cls-38">
              <image width="1928" height="1928" transform="translate(100.62 113.83) scale(.04)" xlink:href="/wp-content/interactivos/factchecking-loreto/fotos_involucrados/jaime_vasquez.jpg"/>
            </g>
          </g>
          <g class="circle-item" data-name="RENÉ CHÁVEZ SILVANO" data-role="Gobernador regional de Loreto" data-category="GOBIERNO LOCAL">
            <circle class="cls-32" cx="630.05" cy="161.18" r="35.53"/>
            <g class="cls-39">
              <image width="454" height="454" transform="translate(594.52 125.87) scale(.15)" xlink:href="/wp-content/interactivos/factchecking-loreto/fotos_involucrados/rene_chavez.jpg"/>
            </g>
          </g>
          <g class="circle-item" data-name="ERWIN FLORETT DÍAZ" data-role="Gerente regional de desarollo de pueblos originarios de Loreto." data-category="GOBIERNO LOCAL">
            <circle class="cls-32" cx="563.61" cy="113.85" r="35.53"/>
            <g class="cls-37">
              <image width="1584" height="1584" transform="translate(531.21 79.71) scale(.04)" xlink:href="/wp-content/interactivos/factchecking-loreto/fotos_involucrados/erwin_florett.jpg"/>
            </g>
          </g>
          <g class="circle-item" data-name="VLADIMIR CHONG RÍOS" data-role="Alcalde provincial de Maynas" data-category="GOBIERNO LOCAL">
            <circle class="cls-32" cx="498.53" cy="65.59" r="35.53"/>
            <g class="cls-35">
              <image width="787" height="787" transform="translate(459.34 28.85) scale(.1)" xlink:href="/wp-content/interactivos/factchecking-loreto/fotos_involucrados/vladimir_chong.jpg"/>
            </g>
          </g>
          <g class="cls-25">
            <text class="cls-29" transform="translate(470 448.94) rotate(-.05)"><tspan class="cls-87" x="0" y="0">S</tspan><tspan x="5.03" y="0">A</tspan><tspan class="cls-62" x="10.36" y="0">L</tspan><tspan class="cls-55" x="14.27" y="0">VITH</tspan><tspan class="cls-96" x="0" y="11.17">O</tspan><tspan class="cls-55" x="6.36" y="11.17">JANAMA</tspan><tspan class="cls-75" x="0" y="22.35">L</tspan><tspan x="4.22" y="22.35">ÓP</tspan><tspan class="cls-100" x="16.07" y="22.35">E</tspan><tspan x="20.96" y="22.35">Z</tspan></text>
          </g>
        </g>
      </svg>
     </div>
    </div>
    </div>
  </div>
</template>

<style>
  .bg-black {
    background-color: #000;
    padding: 65px 0;
  }

  .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20 {
    fill: none;
  }

  .cls-21, .cls-22 {
    fill: #9755ff;
  }

  .cls-2 {
    stroke-dasharray: 1.54 1.54 1.54 1.54 1.54 1.54;
  }

  .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20 {
    stroke: #706f70;
    stroke-width: .78px;
  }

  .cls-23 {
    font-size: 13.19px;
  }

  .cls-23, .cls-24, .cls-22, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31 {
    isolation: isolate;
  }

  .cls-23, .cls-24, .cls-22, .cls-30, .cls-31 {
    font-family: FiraSans-Bold, 'Fira Sans';
    font-weight: 700;
  }

  .cls-23, .cls-32 {
    fill: #ff6d50;
  }

  .cls-3 {
    stroke-dasharray: 1.6 1.6 1.6 1.6 1.6 1.6;
  }

  .cls-4 {
    stroke-dasharray: 1.59 1.59 1.59 1.59 1.59 1.59;
  }

  .cls-24 {
    font-size: 13.19px;
  }

  .cls-24, .cls-33 {
    fill: #5199ff;
  }

  .cls-22, .cls-30 {
    font-size: 13.19px;
  }

  .cls-34 {
    clip-path: url(#clippath-11);
  }

  .cls-35 {
    clip-path: url(#clippath-16);
  }

  .cls-36 {
    clip-path: url(#clippath-10);
  }

  .cls-37 {
    clip-path: url(#clippath-15);
  }

  .cls-38 {
    clip-path: url(#clippath-13);
  }

  .cls-39 {
    clip-path: url(#clippath-14);
  }

  .cls-40 {
    clip-path: url(#clippath-12);
  }

  .cls-5 {
    stroke-dasharray: 1.53 1.53 1.53 1.53 1.53 1.53;
  }

  .cls-41 {
    letter-spacing: 0em;
  }

  .cls-42 {
    letter-spacing: 0em;
  }

  .cls-43 {
    clip-path: url(#clippath-1);
  }

  .cls-44 {
    clip-path: url(#clippath-3);
  }

  .cls-45 {
    clip-path: url(#clippath-4);
  }

  .cls-46 {
    clip-path: url(#clippath-2);
  }

  .cls-47 {
    clip-path: url(#clippath-7);
  }

  .cls-48 {
    clip-path: url(#clippath-6);
  }

  .cls-49 {
    clip-path: url(#clippath-9);
  }

  .cls-50 {
    clip-path: url(#clippath-8);
  }

  .cls-51 {
    clip-path: url(#clippath-5);
  }

  .cls-52 {
    letter-spacing: 0em;
  }

  .cls-6 {
    stroke-dasharray: 1.56 1.56 1.56 1.56 1.56 1.56;
  }

  .cls-26 {
    font-size: 9.31px;
  }

  .cls-26, .cls-27, .cls-28, .cls-29 {
    fill: #fff;
    font-family: FiraSans-Regular, 'Fira Sans';
  }

  .cls-27 {
    font-size: 9.31px;
  }

  .cls-28 {
    font-size: 9.31px;
  }

  .cls-29 {
    font-size: 9.31px;
  }

  .cls-7 {
    stroke-dasharray: 1.49 1.49 1.49 1.49 1.49 1.49;
  }

  .cls-8 {
    stroke-dasharray: 1.54 1.54 1.54 1.54 1.54 1.54;
  }

  .cls-9 {
    stroke-dasharray: 1.62 1.62 1.62 1.62 1.62 1.62;
  }

  .cls-11 {
    stroke-dasharray: 1.59 1.59 1.59 1.59 1.59 1.59;
  }

  .cls-53 {
    letter-spacing: 0em;
  }

  .cls-54 {
    letter-spacing: 0em;
  }

  .cls-55 {
    letter-spacing: 0em;
  }

  .cls-12 {
    stroke-dasharray: 1.58 1.58 1.58 1.58 1.58 1.58;
  }

  .cls-56 {
    letter-spacing: 0em;
  }

  .cls-57 {
    letter-spacing: 0em;
  }

  .cls-13 {
    stroke-dasharray: 1.51 1.51 1.51 1.51 1.51 1.51;
  }

  .cls-58 {
    fill: #5299ff;
  }

  .cls-14 {
    stroke-dasharray: 1.5 1.5 1.5 1.5 1.5 1.5;
  }

  .cls-15 {
    stroke-dasharray: 1.57 1.57 1.57 1.57 1.57 1.57;
  }

  .cls-16 {
    stroke-dasharray: 1.48 1.48 1.48 1.48 1.48 1.48;
  }

  .cls-17 {
    stroke-dasharray: 1.56 1.56 1.56 1.56 1.56 1.56;
  }

  .cls-30, .cls-59 {
    fill: #f2e981;
  }

  .cls-60 {
    letter-spacing: -.08em;
  }

  .cls-61 {
    letter-spacing: -.08em;
  }

  .cls-62 {
    letter-spacing: -.08em;
  }

  .cls-63 {
    letter-spacing: -.02em;
  }

  .cls-64 {
    letter-spacing: -.03em;
  }

  .cls-65 {
    letter-spacing: -.02em;
  }

  .cls-66 {
    letter-spacing: -.02em;
  }

  .cls-67 {
    letter-spacing: -.02em;
  }

  .cls-68 {
    letter-spacing: -.02em;
  }

  .cls-18 {
    stroke-dasharray: 1.55 1.55 1.55 1.55 1.55 1.55;
  }

  .cls-69 {
    letter-spacing: -.02em;
  }

  .cls-19 {
    stroke-dasharray: 1.56 1.56 1.56 1.56 1.56 1.56;
  }

  .cls-70 {
    letter-spacing: -.01em;
  }

  .cls-71 {
    letter-spacing: -.01em;
  }

  .cls-72 {
    letter-spacing: -.01em;
  }

  .cls-73 {
    letter-spacing: -.01em;
  }

  .cls-74 {
    letter-spacing: -.01em;
  }

  .cls-75 {
    letter-spacing: -.04em;
  }

  .cls-76 {
    letter-spacing: -.04em;
  }

  .cls-77 {
    letter-spacing: -.04em;
  }

  .cls-78 {
    letter-spacing: -.04em;
  }

  .cls-79 {
    letter-spacing: -.05em;
  }

  .cls-80 {
    letter-spacing: -.05em;
  }

  .cls-81 {
    letter-spacing: -.04em;
  }

  .cls-82 {
    letter-spacing: -.04em;
  }

  .cls-83 {
    letter-spacing: -.04em;
  }

  .cls-84 {
    letter-spacing: -.03em;
  }

  .cls-85 {
    letter-spacing: -.04em;
  }

  .cls-31 {
    fill: #b3b3b3;
    font-size: 16.03px;
  }

  .cls-86 {
    letter-spacing: 0em;
  }

  .cls-87 {
    letter-spacing: 0em;
  }

  .cls-88 {
    letter-spacing: 0em;
  }

  .cls-89 {
    letter-spacing: 0em;
  }

  .cls-20 {
    stroke-dasharray: 1.54 1.54 1.54 1.54 1.54 1.54;
  }

  .cls-90 {
    letter-spacing: -.01em;
  }

  .cls-91 {
    letter-spacing: -.01em;
  }

  .cls-92 {
    letter-spacing: -.01em;
  }

  .cls-93 {
    letter-spacing: 0em;
  }

  .cls-94 {
    letter-spacing: 0em;
  }

  .cls-95 {
    letter-spacing: 0em;
  }

  .cls-96 {
    letter-spacing: 0em;
  }

  .cls-97 {
    letter-spacing: 0em;
  }

  .cls-98 {
    letter-spacing: 0em;
  }

  .cls-99 {
    letter-spacing: 0em;
  }

  .cls-100 {
    letter-spacing: 0em;
  }

  .cls-101 {
    letter-spacing: 0em;
  }

  .cls-102 {
    letter-spacing: 0em;
  }

  .cls-103 {
    clip-path: url(#clippath);
  }

  g image {
    cursor: pointer;
  }

  .creditos-picture {
    font-family: "Noto Sans";
    padding: 5px 15px;
    margin: 0 15px;
    color: #333;
    font-size: 14px;
    
    .author {
      font-size: 14px;
      color: #747474;
    }
  }

  .tooltip {
    max-width: 220px;
    position: absolute;
    text-align: left;
    padding: 5px;
    font: 12px sans-serif;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 3px;
    pointer-events: none;
  }
  .tooltip h3 {
    font-size: 18px;
    font-family: 'Fira Sans';
    margin: 3px;
  }

</style>

<script>

  import * as d3 from 'd3'
  import images from '@/mixins/images'

  export default {
    name: 'SingleInteractive',
    mixins: [images],
    props: {
      cardText: Object 
    },
    mounted() {
      const tooltip = d3.select(".tooltip")
      .style("opacity", 0)
      .style("display","none")

      d3.selectAll("g.circle-item")
      .on("mouseover", function(event) {
        tooltip.transition()
          .duration(200)
          .style("opacity", .9)
          .style("display","block")
        console.log(this.dataset)
        const msg = `<h3>${this.dataset.name}</h3>
        <div>${this.dataset.role}</div>`

        tooltip.html(msg)
          .style("left", (event.pageX + 10) + "px")
          .style("top", (event.pageY - 28) + "px")
      })
      .on("mouseout", function() {
        tooltip.transition()
          .duration(500)
          .style("opacity", 0)
      })


    }
  }
</script>